import { type FC } from "react";
import { Stack, TableCell, Typography } from "@mui/material";
import type { CustomerSummary } from "../customerSummariesApi";

interface Props {
  client: CustomerSummary;
}

const OfficeContact: FC<Props> = ({ client }) => (
  <Stack direction="row" spacing={1} useFlexGap sx={{ alignItems: "baseline", flexWrap: "wrap" }}>
    <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
      Biuro
    </Typography>
    <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
      {client.email}
    </Typography>
    <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
      {client.phone}
    </Typography>
  </Stack>
);

const ContactPersonsList: FC<Props> = ({ client }) => (
  <Stack spacing={0.75}>
    {client.contacts.map((person, index) => (
      <Stack
        key={`${client.id}-${index}`}
        direction="row"
        spacing={1}
        useFlexGap
        sx={{ alignItems: "baseline", flexWrap: "wrap" }}
      >
        <Typography variant="body2" sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
          {person.name}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
          {person.email}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
          {person.phone}
        </Typography>
      </Stack>
    ))}
  </Stack>
);

const ContactPersonsCell: FC<Props> = ({ client }) => (
  <TableCell sx={{ minWidth: 280 }}>
    {client.contacts.length > 0 ? <ContactPersonsList client={client} /> : <OfficeContact client={client} />}
  </TableCell>
);

export default ContactPersonsCell;
